/* eslint-disable no-unused-vars */

import { jsPDF } from "jspdf";

import { createHeaderSenado } from "../../../model/header";
import { createFooterSenado } from "../../../model/footer";
import moment from 'moment'

export function relatoriolaudoestadoconservacaoibp(estadoConservacao, title) {


  const doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "landscape",
  });

  doc.setFont("", "bold");
  doc.text(`UNIDADE ADM: ${estadoConservacao.itemBemPermanente.lotacao.departamento.descricao
  }`, 10, 44, null, null, "left");

  doc.text(`LOCALIZAÇÃO: ${estadoConservacao.itemBemPermanente.localArmazenamento.descricao
  }`, 10, 50, null, null, "left");


  doc.text(`PRODUTO: ${estadoConservacao.itemBemPermanente.itemRegEntrada.produto.numero
  }`, 10, 56, null, null, "left");



  doc.setFont("", "normal");

  var headersTarefa = [
    "DATA DE AVALIAÇÃO",
    "DESCRIÇÃO",
    "RESP.",
    "ESTADO"
  ];

  var dados = [];


  dados.push({ data: estadoConservacao.data,
    descricao: estadoConservacao.descricao,
    respCriacao: estadoConservacao.repCriacao?estadoConservacao.repCriacao:" ",
    tipoEstado: estadoConservacao.tipoEstadoConservacao.descricao })



  const generateDataTarefa = () => {
    const result = [];

    if (dados) {
      dados.map((c) => {
        result.push({
          "DATA DE AVALIAÇÃO":  moment(String(c.data)).format("DD/MM/YYYY").toString(),
          "DESCRIÇÃO": c.descricao,
          "RESP.": c.respCriacao,
          "ESTADO": c.tipoEstado
        });
      });
    }

    return result;
  };


  console.log(generateDataTarefa());

  doc.table(10, 60, generateDataTarefa(), headersTarefa, {autoSize: true});


  doc.text("__________________________________\n                 Assinatura Responsável\n                          " + (estadoConservacao.repCriacao?estadoConservacao.repCriacao:" "), 10, 100);
  doc.text("__________________________________\n                            Data", 150, 100);


  createHeaderSenado(doc, title);


  // doc.text(
  //   `TOMBAMENTO SAMP: ${ibp.s_numTombAntigo}`,
  //   10,
  //   44,
  //   null,
  //   null,
  //   "left"
  // );

  // doc.text(`Nº SERIE: ${ibp.numSerie}`, 10, 48, null, null, "left");

  // doc.text(
  //   `SITUAÇÃO: ${ibp.situacao === 1 ? "Ativo" : "Inativo"}`,
  //   10,
  //   52,
  //   null,
  //   null,
  //   "left"
  // );

  // doc.text(`Histórico:`, 10, 56, null, null, "left");


  // doc.setFont("", "normal");

  // const lines = doc.splitTextToSize(historico, doc.internal.pageSize.width - 20);
  // const lineHeight = doc.getTextDimensions('text').h; 

  // let y = 60; 

  // lines.forEach(line => {
  //   if (y + lineHeight > doc.internal.pageSize.height - 10) {
  //     createFooterSenado(doc);

  //     doc.addPage(); 
  //     y = 20; 
  //   }
  //   doc.text(line, 10, y);
  //   y += lineHeight; 
  // });

  createFooterSenado(doc);



  doc.save(`Laudo de Avaliação de Estado de Conservação`);
}